var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E9E9E0;}\r\n\t.st1{fill:#D9D7CA;}\r\n\t.st2{fill:#C11032;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#C63247;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1_00000122698601164007587760000015924200122756551341_"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311,59.8H113.9c-5.5,0-10,4.4-10,13.1v360.6c0,2.4,4.4,6.8,10,6.8h272.3c5.5,0,9.9-4.5,9.9-6.8V147.9 c0-4.7-0.6-6.3-1.7-7.4l-79.1-79.1C314.2,60.4,312.6,59.8,311,59.8L311,59.8z M311,59.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M314.6,60.8v80.5H395L314.6,60.8z M314.6,60.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M386.1,440.2H113.9c-5.5,0-10-4.5-10-10V324.7h292.1v105.6C396.1,435.8,391.6,440.2,386.1,440.2L386.1,440.2z  M386.1,440.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M170.9,419.8l23.9-68.4h11l23.8,68.4h-11.5l-4.9-14.2h-25.7l-5,14.2H170.9z M190.2,398.1h20.4l-10.1-29.5 L190.2,398.1z M190.2,398.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M262.4,420.2l-21.3-68.8h12.7l15.9,59.1l16.8-59.1h12.6l-22.3,68.8H262.4z M262.4,420.2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.3,
    y: 351.4,
    className: "st3",
    width: 11.3,
    height: 68.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M219.5,250v-95.1l74.7,47.6L219.5,250z M219.5,250"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvi);
export default __webpack_public_path__ + "static/media/avi.aa1f5c7ccaef6017fe39dd090e2781df.svg";
export { ForwardRef as ReactComponent };